import React from 'react';
import styled from 'styled-components';
import { fontSemiBold } from '../../theme/fonts';
const Wrapper = styled.thead`
  th {
    font-family: ${fontSemiBold};
  }
`;
export const TableHeader = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, props, children);
export default TableHeader;
//# sourceMappingURL=index.js.map